<script>
	import { spring } from 'svelte/motion';
	import { laraStore, coords, opacity, scale } from '../stores/lara.js';
</script>

<style>
	img {
		--scale: 1;

		opacity: var(--opacity);
		position: absolute;
		top: var(--y);
		left: var(--x);

		height: 100px;
		width: 100px;
		margin-top: 20px;
		margin-left: -50px;
		transform: scale(var(--scale));

		transition: opacity 0.2s ease-in-out;
	}
</style>

<img src="./assets/sea-ship.svg" 
	style="
	--x:{$coords.x}px;
	--y:{$coords.y}px;
	--opacity:{$opacity};
	--scale:{$scale}
"
	alt="" />